// crypto.randomUUID() is unsupported on browsers without Web Crypto (our
// browserslist target, "> 1%, last 2 versions", includes some), and core-js does
// not polyfill it. Falling back keeps giftCardAmount and the idempotency key in
// sync instead of throwing mid-assignment in setGiftCardAmount.
export function generateIdempotencyKey() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
    const random = (Math.random() * 16) | 0
    const value = character === 'x' ? random : (random & 0x3) | 0x8
    return value.toString(16)
  })
}
